import { Observable } from 'rxjs';
import { deserializer } from './deserializer';
import { Document } from 'jsonapi-typescript';
import { MetaNew } from '../interfaces/meta-new.interface';
import { Notification } from '../interfaces/notification.interface';

export function deserializeNotifications(
	notification: Document
): Observable<{ notifications: Notification[]; meta: MetaNew }> {
	return new Observable<{ notifications: Notification[]; meta: MetaNew }>((observer) => {
		deserializer.deserialize(notification, (err: Error, response: any) => {
			if (err) {
				observer.error(err);
			} else {
				const data: any[] = Array.isArray(response) ? response : [response];
				observer.next({ notifications: data, meta: (notification as any)?.meta });
				observer.complete();
			}
		});
	});
}

export function deserializeNotification(notification: Document): Observable<Notification> {
	return new Observable<Notification>((observer) => {
		deserializer.deserialize(notification, (err: Error, response: any) => {
			if (err) {
				observer.error(err);
			} else {
				observer.next(response as Notification);
				observer.complete();
			}
		});
	});
}
